import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { UUID } from '~/common/model'
import { AuthWrapped } from '~/modules/navigation/components'

import { UserListPage, UserAddPage, UserDetailPage } from '~/modules/users/view'

const PATH = {
  userList: '/',
  userAdd: 'add',
  userDetail: 'details',
}

export const UserRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('USERS')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={UserListPage} canAccess={canAccess} />} />
      <Route path={PATH.userAdd} element={<AuthWrapped component={UserAddPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.userDetail}/:userId`}
        element={<AuthWrapped component={UserDetailPage} canAccess={canAccess} />}
      />
    </Routes>
  )
}

export const usersLinks = {
  userListLink: () => PATH.userList,
  userAddLink: () => `/${PATH.userAdd}`,
  userDetailLink: (userId: UUID) => `/${PATH.userDetail}/${userId}`,
}
